import { FuseNavigation } from '@fuse/types';
import { hide } from './navigation.functions';
export const navigation: FuseNavigation[] = [
    {
        id       : 'personal',
        title    : 'Personal',
        type     : 'collapsable',
        icon: 'person',
        children:[
            {
                id:'agenda-personal',
                title : 'Agenda Personal',
                type:'collapsable',
                children:[
                    {
                        id: 'agenda-personal',
                        title: 'Agenda Personal',
                        type: 'item',
                        url: '/personal/agenda-personal/agenda/agenda-personal',
                    },
                    {
                        id: 'ver-agenda',
                        title: 'Ver Agenda',
                        type: 'item',
                        url: '/personal/agenda-personal/ver-agenda',
                    },
                ]
            },
            {
                id:'notas',
                title : 'Notas',
                type:'item',
                url:'/personal/notas',
            }
        ]
    },
    {
        id: 'general',
        title: 'General',
        type: 'collapsable',
        icon: 'home',
        children: [
            {
                id: 'consultar-usuario',
                title: 'Consultar Usuario',
                type: 'item',
                url: '/general/consultar-usuario',
            },
            {
                id: 'consultar-titular',
                title: 'Consultar Titular',
                type: 'item',
                url: '/general/consultar-titular',
            },
            {
                id: 'consultar-contratos',
                title: 'Consultar Contratos',
                type: 'item',
                url: '/general/consultar-contrato',
            }
        ]
    },
    {
        id: 'contratos',
        hidden:hide(1),
        title: 'Contratos',
        type: 'collapsable',
        icon: 'assignment',
        children: [
            {
                id: 'dashboard-contratos',
                title: 'Dashboard Contratos',
                type: 'collapsable',
                hidden:hide(2),
                children: [
                    {
                        id:'estadisticas',
                        title:'Estadisticas',
                        type:'item',
                        url:'/contratos/dashboard-contratos/estadisticas',
                        hidden:hide(3)
                    }
                ]
            },
            {
                id: 'contratos-registrados',
                title: 'Contratos Registrados',
                type: 'collapsable',
                hidden: hide(4),
                children: [
                    {
                        id: 'consultar-contrato',
                        title: 'Consultar Contrato',
                        type: 'item',
                        hidden: hide(5),
                        url: '/contratos/contratos-registrados/consultar-contrato'
                    }
                ]
            },
            {
                id: 'pre-contratos',
                title: 'Pre Contratos',
                type: 'collapsable',
                hidden: hide(6),
                children:[
                    {
                        id: 'pendientes',
                        title: 'Pendientes',
                        type: 'item',
                        url: '/contratos/pre-contratos/pendientes',
                        hidden: hide(7)
                    },
                    {
                        id: 'aprobados',
                        title: 'Aprobados',
                        type: 'item',
                        hidden: hide(8),
                        url: '/contratos/pre-contratos/aprobados'
                    }
                ]
            },
            {
                id: 'bitacora-contratos',
                title: 'Bitacora Contratos',
                type: 'collapsable',
                hidden: hide(10),
                children:[
                    {
                        id: 'bitacora-historico',
                        title: 'Bitacora Historico',
                        type: 'item',
                        hidden: hide(11),
                        url: '/contratos/bitacora-contratos/bitacora-historico'
                    },
                    {
                        id: 'bitacora-auditoria',
                        title: 'Bitacora Auditoria',
                        type: 'item',
                        hidden: hide(12),
                        url: '/contratos/bitacora-contratos/bitacora-auditoria'
                    },
                    {
                        id: 'bitacora-rangos',
                        title: 'Bitacora Rangos',
                        type: 'item',
                        hidden: hide(13),
                        url: '/contratos/bitacora-contratos/bitacora-rangos'
                    },
                    {
                        id: 'bitacora-documentos',
                        title: 'Bitacora Documentos',
                        type: 'item',
                        hidden: hide(14),
                        url: '/contratos/bitacora-contratos/bitacora-documentos'
                    }
                ]
            },
            {
                id: 'otros',
                title: 'Otros',
                type: 'collapsable',
                hidden: hide(15),
                children: [
                    {
                        id: 'alianzas',
                        title: 'Alianzas',
                        type: 'item',
                        hidden: hide(16),
                        url:'/contratos/otros/alianzas'
                    },
                    {
                        id: 'tarifas',
                        title: 'Tarifas',
                        type: 'item',
                        hidden: hide(17),
                        url: '/contratos/tarifas'
                    },
                ]
            },
            {
                id: 'info-contratos',
                title: 'Info Contratos',
                type: 'item',
                hidden: hide(18),
                url: '/contratos/info-contratos'
            }
        ]
    },
    {
        id: 'cobranza',
        title: 'Cobranza',
        type: 'collapsable',
        icon: 'monetization_on',
        hidden: hide(19),
        children: [
            {
                id: 'dashboard-cobranza',
                title: 'Dashboard Cobranza',
                type: 'collapsable',
                hidden: hide(20),
                children:[
                    {
                        id: 'estadisticas',
                        title: 'Estadisticas',
                        type: 'item',
                        hidden: hide(21),
                        url: '/cobranza/dashboard-cobranza/estadisticas'
                    }
                ]
            },
            {
                id: 'cartera',
                title: 'Cartera',
                type: 'collapsable',
                hidden: hide(22),
                children: [
                    {
                        id: 'cobros-fijos',
                        title: 'Cobros Fijos',
                        type: 'group',
                        children: [
                            {
                                id: 'agregar-cobros-fijos',
                                title: 'Agregar Cobros Fijos',
                                type: 'item',
                                url: '/cobranza/cartera/cobros-fijos/agregar-cobros'
                            },
                            {
                                id: 'registrar-cobros-fijos',
                                title: 'Registrar Cobro',
                                type: 'item',
                                url: '/cobranza/cartera/cobros-fijos/registrar-cobro'
                            }
                        ]
                    },
                    {
                        id: 'cobros-ocasionales',
                        title: 'Cobros Ocasionales',
                        type: 'group',
                        children: [
                            {
                                id: 'programar-cobros',
                                title: 'Programar Cobros',
                                type: 'item',
                                hidden: hide(23),
                                url: '/cobranza/cartera/cobros-ocasionales/programar-cobros'
                            },
                            {
                                id: 'ver-agenda',
                                title: 'Diligencias',
                                type: 'item',
                                hidden: hide(24),
                                url: '/cobranza/cartera/cobros-ocasionales/agenda-calendario/ver-agenda'
                            },
                            {
                                id: 'ver-cobros',
                                title: 'Ver Agenda',
                                type: 'item',
                                hidden: hide(24),
                                url: '/cobranza/cartera/cobros-ocasionales/ver-cobros'
                            },
                        ]
                    },
                    {
                        id: 'Cartera Vencida',
                        title: 'Cartera Vencida',
                        type: 'group',
                        children: [
                            {
                                id: 'facturas dobles',
                                title: 'Facturas dobles',
                                type: 'item',
                                url: 'vencida/dobles'
                            }
                        ]
                    }
                ]
            },
            {
                id: 'cobrador',
                title: 'Cobrador',
                type: 'collapsable',
                hidden: hide(25),
                children: [
                    {
                        id: 'ver-agenda',
                        title: 'Agenda Cobrador',
                        type: 'item',
                        hidden: hide(26),
                        url: '/cobranza/cobrador/ver-agenda'
                    },
                    {
                        id: 'entrega-factura',
                        title: 'Entrega de Factura',
                        type: 'item',
                        hidden: hide(27),
                        url: '/cobranza/cobrador/entrega-factura'
                    }
                ]
            },
            {
                id: 'tesoreria',
                title: 'Tesoreria',
                type: 'collapsable',
                hidden: hide(28),
                children: [
                    {
                        id: 'debitos-aprobados',
                        title: 'Débitos Aprobados',
                        type: 'item',
                        hidden: hide(29),
                        url: '/cobranza/tesoreria/debitos-aprobados'
                    },
                    {
                        id: 'gestion-cobrador',
                        title: 'Gestion Cobrador',
                        type: 'item',
                        hidden: hide(30),
                        url: '/cobranza/tesoreria/gestion-cobrador'
                    }
                ]
            },
            {
                id: 'debitos-activos',
                title: 'Débitos Activos',
                type: 'collapsable',
                hidden: hide(31),
                children: [
                    {
                        id: 'agregar-debito',
                        title: 'Agregar a Débito Act.',
                        type: 'item',
                        hidden: hide(34),
                        url: '/cobranza/debitos-activos/agregar-debito-auto'
                    },
                    {
                        id: 'registrar-debitos',
                        title: 'Registrar Débitos',
                        type: 'item',
                        hidden: hide(32),
                        url: '/cobranza/debitos-activos/registrar-debitos'
                    },
                    {
                        id: 'gestionar-debitos',
                        title: 'Gestionar Débitos',
                        type: 'item',
                        hidden: hide(33),
                        url: '/cobranza/debitos-activos/gestionar-debitos'
                    },
                    {
                        id: 'historico-debitos',
                        title: 'Historico Debitos',
                        type: 'item',
                        hidden: hide(34),
                        url: '/cobranza/debitos-activos/historico-debitos'
                    }
                ]
            },
            {
                id: 'informes-cobranza',
                title: 'Informes Cobranza',
                type: 'collapsable',
                hidden: hide(35),
                children: [
                    {
                        id: 'auditoria-cartera',
                        title: 'Auditoria Cartera',
                        type: 'item',
                        hidden: hide(35),
                        url: '/cobranza/informes-cobranza/auditoria-cartera'
                    },
                    {
                        id: 'informesGenerales',
                        title: 'Informes Generales',
                        type: 'group',
                        children:[
                            {
                                id: 'gestionarCartera',
                                title: 'Gestion cartera',
                                type: 'item',
                                url: '/cobranza/informes-cobranza/gestion-cartera'
                            },
                        ]
                    },
                ]
            },

        ]
    },
    {
        id: 'contabilidad',
        title: 'Contabilidad',
        type: 'collapsable',
        icon:'work',
        hidden: hide(36),
        children: [
            {
                id: 'desprendibles-nomina',
                title: 'Desprendibles de Nomina',
                type: 'item',
                hidden: hide(37),
                url: '/contabilidad/desprendibles-nomina'
            },
            {
                id: 'informes-contabilidad',
                title: 'Informes Contabilidad',
                type: 'item',
                hidden: hide(38),
                url: '/contabilidad/informes-contabilidad'
            },
            {
                id: 'proveedor',
                title: 'Proveedor',
                type: 'collapsable',
                hidden: hide(39),
                children: [
                    {
                        id: 'crear-proveedor',
                        title: 'Crear Proveedor',
                        type: 'item',
                        hidden: hide(40),
                        url: '/contabilidad/proveedor/crear-proveedor'
                    },
                    {
                        id: 'registrar-factura',
                        title: 'Registrar Factura',
                        type: 'item',
                        hidden: hide(41),
                        url: 'cobranza/proveedor/registrar-factura'
                    },
                    {
                        id: 'facturas-por-pagar',
                        title: 'Facturas Por Pagar',
                        type: 'item',
                        hidden: hide(102),
                        url: '/contabilidad/proveedor/facturas-por-pagar'
                    },
                    {
                        id: 'historial-facturas-por-proveedor',
                        title: 'Historial Facturas Por Proveedor',
                        type: 'item',
                        hidden: hide(42),
                        url: '/contabilidad/proveedor/historial-facturas-por-proveedor'
                    }
                ]
            }
        ]
    },
    {
        id:'Facturacion',
        title:'Facturacion',
        type:'collapsable',
        icon:'receipt',
        hidden: hide(43),
        children:[
            {
                id: 'generar-facturas',
                title: 'Generar Facturas',
                type: 'item',
                hidden: hide(44),
                url: 'Facturacion/generar-facturas'
            },
            {
                id: 'ver-facturas',
                title: 'Ver Facturas',
                type: 'item',
                hidden: hide(45),
                url: 'Facturacion/ver-facturas'
            },
            {
                id: 'notificar-factura',
                title: 'Notificar Factura',
                type: 'item',
                hidden: hide(46),
                url: 'Facturacion/notificar-factura'
            }
        ]
    },
    {
        id: 'servicio-medico',
        title: 'Servicio Médico',
        type: 'collapsable',
        icon: 'favorite',
        hidden: hide(47),
        children: [
            {
                id: 'dashboard-servicio-medico',
                title: 'Dashboard Servicio Medico',
                type: 'collapsable',
                hidden: hide(48),
                children: [
                    {
                        id: 'estadisticas',
                        title: 'Estadisticas',
                        type: 'item',
                        hidden: hide(49),
                        url: '/servicio-medico/dashboard-servicio-medico/estadisticas'
                    }
                ]
            },
            {
                id: 'despacho',
                title: 'Despacho',
                type: 'item',
                hidden: hide(50),
                url: '/servicio-medico/despacho'
            },
            {
                id: 'historias-clinicas',
                title: 'Historias Clinicas',
                type: 'item',
                hidden: hide(51),
                url: '/servicio-medico/historias-clinicas'
            },
            {
                id: 'farmacia',
                title: 'Farmacia',
                hidden: hide(52),
                type: 'collapsable',
                children: [
                    {
                        id: 'inventario-medicamentos',
                        title: 'Inventario Medicamentos',
                        type: 'item',
                        hidden: hide(53),
                        url: '/servicio-medico/farmacia/inventario-medicamentos'
                    },
                    {
                        id: 'consumos',
                        title: 'Consumos',
                        type: 'item',
                        hidden: hide(54),
                        url: '/servicio-medico/farmacia/consumos'
                    }
                ]
            },
            {
                id: 'calidad',
                title: 'Calidad',
                type: 'collapsable',
                hidden: hide(55),
                children: [
                    {
                        id: 'IASSseguimiento',
                        title: 'IASSseguimiento',
                        type: 'item',
                        hidden: hide(56),
                        url: '/servicio-medico/calidad/IASSseguimiento'
                    },
                    {
                        id: 'Informes-calidad',
                        title: 'Informes Calidad',
                        type: 'item',
                        hidden: hide(57),
                        url: '/servicio-medico/calidad/Informes-calidad'
                    }
                ]
            },
            {
                id: 'gestion-personal-operativo',
                title: 'Gestion de Personal Operativo',
                type: 'collapsable',
                hidden: hide(58),
                children: [
                    {
                        id: 'agregar-personal',
                        title: 'agregar-personal',
                        type: 'item',
                        hidden: hide(59),
                        url: '/servicio-medico/gestion-personal-operativo/agregar-personal'
                    },
                    {
                        id: 'turnos',
                        title: 'Turnos',
                        type: 'group',
                        hidden: hide(60),
                        children: [
                            {
                                id: 'asignar-turnos',
                                title: 'Asignar Turnos',
                                type: 'item',
                                hidden: hide(61),
                                url: '/servicio-medico/gestion-personal-operativo/turnos/asignar-turnos'
                            },
                            {
                                id: 'gestionar-turnos',
                                title: 'Gestionar Turnos',
                                type: 'item',
                                hidden: hide(62),
                                url: '/servicio-medico/gestion-personal-operativo/turnos/gestionar-turnos'
                            },
                            {
                                id: 'cambio-turnos',
                                title: 'Cambio de Turnos',
                                type: 'item',
                                hidden: hide(63),
                                url: '/servicio-medico/gestion-personal-operativo/turnos/cambio-turnos'
                            },
                            {
                                id: 'turnos-extras',
                                title: 'Turnos Extras',
                                type: 'item',
                                hidden: hide(64),
                                url: '/servicio-medico/gestion-personal-operativo/turnos/turnos-extras'
                            }
                        ]
                    },
                ]
            },
            {
                id: 'informes-servicio-medico',
                title: 'Informes Servicio Medico',
                type: 'item',
                hidden: hide(65),
                url: '/servicio-medico/informes-servicio-medico'
            }

        ]
    },
    {
        id: 'servicio-cliente',
        title: 'Servicio al Cliente',
        type: 'collapsable',
        icon:'group',
        hidden: hide(72),
        children:[
            {
                id: 'PQRS',
                title: 'PQRS',
                type: 'item',
                hidden: hide(73),
                url: '/servicio-cliente/PQRS'
            },
            {
                id: 'post-servicio',
                title: 'Post servicio',
                type: 'item',
                hidden: hide(74),
                url: '/servicio-cliente/post-servicio'
            },
            {
                id: 'apoyo-usuario',
                title: 'Apoyo al Usuario',
                type: 'collapsable',
                hidden: hide(75),
                children: [
                    {
                        id: 'beneficiarios',
                        title: 'Beneficiarios',
                        type: 'item',
                        hidden: hide(76),
                        url: '/servicio-cliente/apoyo-usuario'
                    },
                    {
                        id: 'titulares',
                        title: 'Titulares',
                        type: 'item',
                        hidden: hide(77),
                        url: '/servicio-cliente/apoyo-usuario/titulares'
                    },
                    {
                        id: 'Auditorias',
                        title: 'auditorias',
                        type: 'item',
                        hidden: hide(78),
                        url: '/servicio-cliente/apoyo-usuario/auditorias'
                    },
                    {
                        id: 'monitoreo',
                        title: 'Monitoreo',
                        type: 'item',
                        hidden: hide(79),
                        url: '/servicio-cliente/apoyo-usuario/monitoreo'
                    }
                ]
            },
            {
                id: 'fidelizacion-clientes',
                title: 'Fidelizacion Clientes',
                type: 'collapsable',
                hidden: hide(80),
                children: [
                    {
                        id: 'gestion-ingreso-usuarios',
                        title: 'Gestión Ingreso Usuarios',
                        type: 'item',
                        url: '/servicio-cliente/fidelizacion-clientes/gestion-ingreso-usuarios'
                    }
                ]
            },
            {
                id: 'Informes Servicio Cliente',
                title: 'informes-servicio-cliente',
                type: 'item',
                hidden: hide(81),
                url: '/servicio-cliente/informes-servicio-cliente'
            }
        ]
    },
    {
        id: 'comercial',
        title: 'Comercial',
        icon:'store',
        type: 'collapsable',
        hidden: hide(66),
        children: [
            {
                id: 'dashboard-comercial',
                title: 'Dashboard Comercial',
                type: 'collapsable',
                hidden: hide(67),
                children: [
                    {
                        id: 'estadisticas',
                        title: 'estadisticas',
                        type: 'item',
                        hidden: hide(68),
                        url: '/comercial/dashboard-comercial/estadisticas'
                    }
                ]
            },
            {
                id: 'gestion-contratos',
                title: 'Gestion de Contratos',
                type: 'item',
                hidden: hide(69),
                url: '/comercial/gestion-contratos'
            },
            {
                id: 'gestion-empresas',
                title: 'Gestion Empresas',
                type: 'item',
                hidden: hide(70),
                url: '/comercial/gestion-empresas'
            },
            {
                id: 'informes-comercial',
                title: 'Informes Comercial',
                type: 'item',
                hidden: hide(71),
                url: '/comercial/informes-comercial'
            }
        ]
    },
    {
        id: 'mercadeo',
        title: 'Mercadeo',
        icon: 'business_center',
        type: 'collapsable',
        hidden: hide(82),
        children: [
            {
                id: 'mensajes-texto',
                title: 'Mensajes de Texto',
                type: 'collapsable',
                hidden: hide(83),
                children: [
                    {
                        id: 'predefinidos',
                        title: 'Predefinidos',
                        type: 'item',
                        hidden: hide(84),
                        url: '/mercadeo/mensajes-texto/predefinidos'
                    },
                    {
                        id: 'mensajes-personalizados',
                        title: 'Mensajes Personalizados',
                        type: 'item',
                        hidden: hide(85),
                        url: '/mercadeo/mensajes-texto/mensajes-personalizados'
                    }
                ]
            }
        ]
    },
    {
        id: 'recursos-humanos',
        title: 'Recursos Humanos',
        icon: 'accessibility_new',
        type: 'collapsable',
        hidden: hide(86),
        children: [
            {
                id: 'solicitar-permisos',
                title: 'Solicitar Permisos',
                type: 'item',
                url: '/recursos-humanos/solicitar-permisos'
            },
            {
                id: 'solicitud-de-permisos',
                title: 'Solicitud de Permisos',
                type: 'item',
                hidden: hide(87),
                url: '/recursos-humanos/solicitar-permisos'
            },
            {
                id: 'personal',
                title: 'Personal',
                type: 'collapsable',
                hidden: hide(88),
                children: [
                    {
                        id: 'hoja-de-vida',
                        title: 'Hoja de Vida',
                        type: 'item',
                        hidden: hide(89),
                        url: '/recursos-humanos/personal/hoja-de-vida'
                    },
                    {
                        id: 'novedades',
                        title: 'novedades',
                        type: 'item',
                        hidden: hide(90),
                        url: '/recursos-humanos/solicitud-permisos-personal/novedades'
                    }
                ]
            }
        ]
    },
    {
        
        id: 'finanzas',
        title: 'Finanzas',
        type:'collapsable',
        icon: 'attach_money',
        children:[
            {
                id:'gastos-empresas',
                title:'Gastos Empresas',
                type: 'collapsable',
                children:[  
                    {
                        id:'dashboard',
                        title:'Dashboard',
                        url:'/finanzas/dashboard',
                        type:'item',
                        
                    },
                    {
                        id:'agregar-gastos-ingresos',
                        title:'Agregar gastos - ingresos',
                        url:'/finanzas/empresas',
                        type:'item',
                    },
                    {
                        id:'informe',
                        title:'Informe',
                        type:'item',
                        url:'/finanzas/informes',
                    },
                ]
            }, 
            {
                id:'valoracionEmpresas', 
                title:' Valoracion Empresas', 
                type: 'collapsable', 
                children:[
                    
                    {
                        id:'dashboardValoracion', 
                        title:'Dashboard', 
                        url:'/finanzas/valoracionE/dashboard', 
                        type:'item'
                    }, 

                    {
                        id:'valoracionE', 
                        title:'Valoracion Empresas', 
                        type:'item', 
                        url:'finanzas/valoracionE'
                    }
                    
                ]
                
            } 
        ]
    },
    {
        id: 'sistemas',
        title: 'Sistemas',
        icon:'laptop_mac',
        type: 'collapsable',
        hidden: hide(91),
        children: [
            {
                id: 'gestionar-usuario',
                title: 'Gestionar Usuario',
                type: 'item',
                hidden: hide(92),
                url: '/sistemas/gestionar-usuario'
            },
            {
                id: 'agregar-usuario',
                title: 'Agregar Usuario',
                type: 'item',
                hidden: hide(93),
                url: '/sistemas/agregar-usuario'
            },
            {
                id: 'permisos',
                title: 'Permisos',
                type: 'item',
                hidden: hide(94),
                url: '/sistemas/permisos'
            },
            {
                id: 'soporte-tecnico',
                title: 'Soporte Tecnico',
                type: 'item',
                hidden: hide(95),
                url: '/sistemas/soporte-tecnico'
            },
            {
                id: 'inventario-equipos',
                title: 'Inventario Equipos',
                type: 'item',
                hidden: hide(96),
                url: '/sistemas/inventario-equipos'
            }
        ]
    },
    {
        id: 'informes',
        title: 'Informes',
        icon: 'dashboard',
        type: 'collapsable',
        hidden: hide(97),
        children: [
            {
                id: 'area-operativa',
                title: 'Area Operativa',
                type: 'item',
                hidden: hide(98),
                url: '/informes/area-operativa'
            },
            {
                id: 'area-administrativa',
                title: 'Area Administrativa',
                type: 'item',
                hidden: hide(99),
                url: '/informes/area-administrativa'
            },
            {
                id: 'area-comercial',
                title: 'Area Comercial',
                type: 'item',
                hidden: hide(100),
                url: '/informes/area-comercial'
            },
            {
                id: 'area-servicio-cliente',
                title: 'Area Servicio Cliente',
                type: 'item',
                hidden: hide(101),
                url: '/informes/area-servicio-cliente'
            }
        ]
    },
    {
        id:'temporales',
        title:'temporales',
        type:'collapsable',
        icon: 'timer',
        children:[
            {
                id:'direcciones',
                title:'direcciones',
                type:'item',
                url:'/temporales/direcciones'
            }
        ]
    },
    
];
